import { get } from 'svelte/store';

import { pageId } from '../store/index';

import { isMsiPage } from './pageType';

import { getPageTrackingConfig } from '@/utils/creditCardTrackParams';
import url from '@/utils/url';

/** msi 埋点 page_id：首页与 fifa 登录子页共用，不追加 _after */
export const getLandingTrackPageId = () => {
    const { trackingPageId, pageId: configPageId } = getPageTrackingConfig();
    const storePageId = get(pageId);
    const queryPageId = url.get('pageId') || '';

    return (
        trackingPageId ||
        configPageId ||
        storePageId ||
        queryPageId ||
        ''
    );
};

export const resolveTrackPageId = () => {
    if (isMsiPage()) {
        return getLandingTrackPageId();
    }

    const { pageId: configPageId } = getPageTrackingConfig();

    return configPageId || get(pageId) || url.get('pageId') || '';
};

export const resolveTrackPageVersion = () => {
    const { pageVersion } = getPageTrackingConfig();

    return pageVersion || '2026V1';
};
